import React, { useState, useEffect } from "react";
import WebActionPage from "./WebActionPage";
import ScriptActionPage from "./ScriptActionPage";
import { useSelector, useDispatch } from "react-redux";
import IssueCommentActionPage from "../../../../connections/atlassian/jira/components/action/IssueCommentActionPage";
import CreateIssueActionPage from "../../../../connections/atlassian/jira/components/action/CreateIssueActionPage";
import UpdateIssueActionPage from "../../../../connections/atlassian/jira/components/action/UpdateIssueActionPage";
import { ActionUIRenderType } from "../../../../common/constants/core/action.constants";
import { JiraUIRenderType } from "../../../../connections/atlassian/jira/jira.util";
import { useParams } from "react-router-dom";
import InputWithValidation from "../../../../common/components/InputWithValidation";
import ActionDescription from "./ActionDescription";
import { setEditorSaved, rerender } from "../../../../redux/actions/integrationActions";
import { Label } from "@atlaskit/form";
const ActionRenderer = () => {
  const flow = useSelector((state) => state.integration.flow);
  const dispatch = useDispatch();
  const { sectionId } = useParams();
  const [currentAction, setCurrentAction] = useState(null);
  const [actionName, setAcionName] = useState("");
  const [actionDescription, setActionDescription] = useState("");

  useEffect(() => {
    if (flow?.actions) {
      const action = flow.actions.find((a) => a.id === sectionId);
      if (action) {
        setAcionName(action.name ? action.name : "");
        setActionDescription(action.description ? action.description : "");
        setCurrentAction(action);
      }
    }
  }, [sectionId, flow]);

  const mergeCurrentActionToFlow = () => {
    if (!flow?.actions || !currentAction) return;
    const action = flow.actions.find((a) => a.id === sectionId);
    if (!action) return;
    const index = flow.actions.indexOf(action);
    flow.actions[index] = currentAction;
    dispatch(rerender());
  };

  const onChange = (e) => {
    if (!currentAction) return;
    const { name, value } = e.target;

    switch (name) {
      case "actionName": {
        const trimmedName = value.substring(0, 250);
        setAcionName(trimmedName);
        currentAction.name = trimmedName;
        break;
      }
      case "actionDescription": {
        const descriptionValue = value.substring(0, 500);
        setActionDescription(descriptionValue);
        currentAction.description = descriptionValue;
        break;
      }
      default:
        return;
    }

    setCurrentAction(currentAction);
    mergeCurrentActionToFlow();
    dispatch(setEditorSaved(false));
  };

  const action = currentAction || flow?.actions?.find((a) => a.id === sectionId);

  return (
    <>
      <div style={{ paddingLeft: 7 }}>
        <Label>Name</Label>
        <InputWithValidation
          fieldTitle={""}
          fieldName={"actionName"}
          onChange={onChange}
          inputValue={actionName ? actionName : ""}
          maxChar={70}
          minChar={4}
          type="textfield"
        />
        <ActionDescription description={actionDescription} onChange={onChange} />
      </div>
      {action && !action.uiRenderer && <WebActionPage />}
      {action && action.uiRenderer && action.uiRenderer === ActionUIRenderType.SCRIPT_ACTION_TYPE && <ScriptActionPage />}
      {action && action.uiRenderer && action.uiRenderer === ActionUIRenderType.WEB_ACTION && <WebActionPage />}
      {action && action.uiRenderer && action.uiRenderer === JiraUIRenderType.JIRA_COMMENT && <IssueCommentActionPage />}
      {action && action.uiRenderer && action.uiRenderer === JiraUIRenderType.JIRA_CREATE_ISSUE && <CreateIssueActionPage />}
      {action && action.uiRenderer && action.uiRenderer === JiraUIRenderType.JIRA_UPDATE_ISSUE && <UpdateIssueActionPage />}
    </>
  );
};
export default ActionRenderer;
